function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpBold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22.5A10.5,10.5,0,1,1,22.5,12,10.5,10.5,0,0,1,12,22.5Z",
    style: {
      fill: "#3d7ef5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.08,16.53a1.24,1.24,0,1,0,1.24,1.24A1.26,1.26,0,0,0,12.08,16.53Z",
    style: {
      fill: "#3d7ef5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.37,5A4.35,4.35,0,0,0,8,8.13l1.71.67a2.65,2.65,0,0,1,2.66-1.9,2,2,0,0,1,2.18,1.9c0,2.27-3.42,2.46-3.42,5.31a5.09,5.09,0,0,0,.1.86h1.71v-.19c0-2.95,3.7-2.38,3.7-6.17C16.64,6.71,14.93,5,12.37,5Z",
    style: {
      fill: "#3d7ef5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBold);
export default __webpack_public_path__ + "static/media/help-bold.071ebd249da5506f0c68e0bdcfa61f27.svg";
export { ForwardRef as ReactComponent };